<i18n src="../../locales/lang.json"></i18n>

<template>
  <draggable v-bind="dragOptions"
               tag="div"
               class="item-container"
               :list="list"
               :value="value"
               ghost-class="ghost"
               chosen-class="chosen"
               @input="emitter"
               @add="dragAdded" @move="dragMoved" @sort="dragSorted" @clone="dragCloned" @update="dragUpdated" @end="dragEnd" @start="dragStart" @change="dragChanged" style="width:100%">


    <div v-if="el.IsDeleted != true" class="item-group" v-bind:class="{chosen: overelement == el}" :key="el.Id" v-for="el in realValue" @mouseenter="mouseEnter1(el)" @dragenter="mouseEnter1(el)" @mouseleave="mouseLeave1(el)">


      <div v-if="el.ElementType == 1" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-text v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-text>
      </div>
      <div v-if="el.ElementType == 2" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-checkbox v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-checkbox>
      </div>
      <div v-if="el.ElementType == 9" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-qrcode v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-qrcode>
      </div>
      <div v-if="el.ElementType == 5" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-upload v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-upload>
      </div>
      <div v-if="el.ElementType == 6" class="item">
        <element-textfield v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-textfield>
      </div>
      <div v-if="el.ElementType == 7" class="item">
        <element-textarea v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-textarea>
      </div>
      <div v-if="el.ElementType == 0" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-image v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-image>
      </div>

      <div v-if="el.ElementType == 8" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-select v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-select>
      </div>
      <div v-if="el.ElementType == 10" class="item">
        <element-worknote v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-worknote>
      </div>

      <div v-if="el.ElementType == 11" class="item">
        <element-button v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-button>
      </div>
      <div v-if="el.ElementType == 12" class="item">
        <element-slideshow v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings">
          <nested-property class="item-sub" v-bind:class="{chosen: overelement == el, 'active-drop':el.ElementType == 4}" v-model="el.Elements" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings" />
        </element-slideshow>
      </div>
      <div v-if="el.ElementType == 13" class="item">
        <element-page v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings">
          <nested-property class="item-sub" v-bind:class="{chosen: overelement == el, 'active-drop':el.ElementType == 4}" v-model="el.Elements" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings" />
        </element-page>
      </div>
      <div v-if="el.ElementType == 14" class="item">
        <element-page-ending v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings">
          <nested-property class="item-sub" v-bind:class="{chosen: overelement == el, 'active-drop':el.ElementType == 4}" v-model="el.Elements" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings" />
        </element-page-ending>
      </div>

      <div v-if="el.ElementType == 17" class="item">
        <element-booking v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-booking>
      </div>

      <div v-if="el.ElementType == 16" class="item">
        <element-camera v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-camera>
      </div>

      <div v-if="el.ElementType == 18" class="item">
        <element-edit-video v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-edit-video>
      </div>
      <div v-if="el.ElementType == 19" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-title v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-title>
      </div>
      <div v-if="el.ElementType == 20" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-hidden v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-hidden>
      </div>

      <div v-if="el.ElementType == 21" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-html-editor v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-html-editor>
      </div>
      <div v-if="el.ElementType == 22" class="item" v-bind:class="{'chosen-outline': overelement == el}">
        <element-title v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-title>
      </div>
      <div class="item" v-if="el.ElementType == 4">
        <div class="row p-0 m-0">
          <div class="col-12" style="position:relative">
            <i class="icon-move handle" style="float:left;margin-top:12px;"></i>
            <procedure-expand show="true" v-bind:enabled="el.ElementType == 4" class="item col-12" v-bind:class="{'chosen-outline': overelement == el}" v-bind:el="el" style="position:absolute; left:31px;">
              <nested-property class="item-sub" v-bind:class="{chosen: overelement == el, 'active-drop':el.ElementType == 4}" v-model="el.Elements" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings" />
            </procedure-expand>
            <element-controls class="element-controls" v-bind:el="el" @deleteItem="deleteItem" @clickItem="clickItem" @clickSettings="clickSettings"></element-controls>
          </div>
        </div>
      </div>

    </div>
</draggable>
</template>

<script>
  import draggable from "vuedraggable";
  import ProcedureExpand from './procedure-expand.vue'

  var overelement = null;

  export default {
    name: "nested-property",
    components: {
      ProcedureExpand
    },
    data() {
      return {
        overelement
      }
    },
    methods: {
      async setElements(elements) {
        Vue.set(this, "elements", elements);
        this.list = elements;
        //this.$forceUpdate();
        //this.elements = elements;
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      emitter(value) {
        //alert(value);
        this.$emit("input", value);
      },
      dragChanged(event) {
        if (event != null && event.added != null && typeof (event.added) != "underfined") {
          var parent = this.getParent(event.added.element);
          if (parent != null) {
            event.added.element.ParentId = parent.Id;
          }
          else {
            event.added.element.ParentId = null;
          }
          this.$store.markAsChanged();
        }

        if (event != null && event.moved != null && typeof (event.moved) != "underfined") {
          var parent = this.getParent(event.moved.element);
          if (parent != null) {
            event.moved.element.ParentId = parent.Id;
          }
          else {
            event.moved.element.ParentId = null;
          }
          this.$store.markAsChanged();
        }


      },
      dragStart(event) {
        //alert(event.item.getAttribute("data-type"));
        //$(event.item).replaceWith($('<div>Bar X - starting</div>'))

      },
      dragEnd(event) {
        //alert(event.item.type);
        //$(event.item).replaceWith($('<div>Bar X - ended</div>'))

      },
      dragUpdated(event) {
        //$(event.item).replaceWith($('<div>Bar X - updated</div>'))
        //alert(event.item.type);
      },
      dragCloned(event) {
        //alert(event.item.type);
        //$(event.item).replaceWith($('<div>Bar X - cloned</div>'))
      },
      dragSorted(event) {
        //$(event.item).replaceWith($('<div>Bar X - sorted</div>'))

      },
      dragMoved(event) {
        //$(event.item).replaceWith($('<div>Bar X - moved</div>'))

      },
      dragAdded(event) {
        //var t = $(event.item).children()[0].getAttribute("data-type")
        //var t = event.item.getAttribute("data-type")
        //alert("t:" + t + " id:" + event.item.id);
        //alert("t:" + t + " id:" + event.item.id);
        //$(event.item).html('something depending on t:' + t);

        //$(event.item).replaceWith($('something depending on t:' + t))
      },

      addItem(event) {
        //$(event.item).replaceWith($('<div>Bar X</div>'))
        //event.item = $('<div>test</div>')[0];
        //event.clone = $('<div>test</div>')[0];
        //alert($(event.item).html());

      },
     

      deleteItem(id) {
        var currentObject = this;
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        try {
          this.$http.get('/api/Procedures/v1/Element/UserInputs?elementId=' + id).then(async response => {
            
            var userInputs = response.data;            
            if (userInputs.length > 0) {
              bootbox.confirm(this.$t('delete_element_data_loss_warning'), function (result) {
                if (result) {
                  currentObject.$emit('deleteItem', id);
                  //this.$forceUpdate();
                }
              });
            } else {
              currentObject.$emit('deleteItem', id);
              this.$forceUpdate();
            }

          });
        } catch (err) {
          alert('some error:' + err)
          return userInputs;
        }
                
      },
      getParent(element) {
        var elements = this.getFlat(this.procedure.Elements);
        for (var i = 0; i < elements.length; i++) {
          for (var k = 0; k < elements[i].Elements.length; k++) {
            if (elements[i].Elements[k] == element)
              return elements[i];
          }
        }
        return null;
      },
      getFlat(elements) {
        var arr = [];
        for (var i = 0; i < elements.length; i++) {
          arr.push(elements[i]);
          var children = this.getFlat(elements[i].Elements);
          for (var k = 0; k < children.length; k++) {
            arr.push(children[k]);
          }
        }
        return arr;
      },
      
      handleRefresh(val) {
        //this.$forceUpdate();
      },
      mouseEnter1(el) {
        this.overelement = el;
        console.log("entered" + el.Id)
      },
      mouseLeave1(el) {
        this.overelement = null;
        console.log("leave" + el.Id)
      }
    },
    components: {
      draggable
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "description",
          disabled: false,
          ghostClass: "ghost",
          chosenClass: "chosen",
          animation: 500,
          preventOnFilter: false,
          handle: ".handle"
        };
      },
      realValue() {
        return this.value ? this.value : this.list;
      },
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 1");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    props: {
      value: {
        required: false,
        type: Array,
        default: null
      },
      list: {
        required: false,
        type: Array,
        default: null
      },
      displaydropmessage: {
        required: false,
        type: Boolean,
        default: false
      },
      over: {
        required: false,
        type: Boolean,
        default: false
      },
    },
    mounted() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    }
  };
</script>

<style scoped>


  /*Make the controls a little more quite*/

  .icon-move, .item .element-controls, .item btn-icon, .item .btn-icon i {
    color: #ddd;
  }

  .item .form-control {
    border-color: transparent;
  }

  .item:focus-within .form-control, .form-control:active, .form-control:focus {
    border-color: #2196f3;
  }

  .item:focus-within .element-controls, .item:hover .element-controls,
  .item:hover .icon-move,
  .item:focus-within .icon-move,
  .item:hover .btn-icon i, .item:focus-within .btn-icon i {
    color: black;
  }

  .item:active .custom-control-label::before, .item:focus-within .custom-control-label::before, .item:hover .custom-control-label::before {
    border-color: black;
  }

  /*End Make the controls a little more quite*/

  .item .card-group-control .card-title > a::before {
    color: black;
  }

  .item:focus-within .card-group-control .card-title > a::before {
      color:black;
  }

  .element-controls {
    float:initial;
    margin-right: initial;
    position: absolute;
    top: 0px;
    right: 10px;
  }
  
  /*
    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }

    .item-group > .chosen {
        background-color:pink;
    }

    .item .ghost {
      background-color: pink;
    }

    .item .chosen {
      background-color: pink;
    }

    .item-group .chosen {
      background-color: pink;
    }

    .item-group > .item .chosen {
      background-color: pink;
    }

    .item-group > .item > .chosen {
      background-color: pink;
    }


    .chosen-outline {
      background-color: #ccc;
    }
  */
  .chosen {
  }

    .subdrop-hint {
      position: absolute;
      top: 59px;
      left: 45px;
      min-height:50px;
    }

  .icon-menu {
    /*color: #ccc;*/
  }

  .icon-menu {
    /*color: #000;*/
  }

    .handle {
      cursor: pointer;
    }

    .handle:hover {

    }

    .form-control:not(.border-bottom-1):not(.border-bottom-2):not(.border-bottom-3):focus {
      border-color: #DCDDDE;
    }

    .form-control:focus {
      outline: 0;
      box-shadow: 0 0 0 0 transparent,0 1px 0 #DCDDDE;
    }

    .item-container {
      margin: 0;
     /* min-height:70px;*/
    }

    .item {
      padding: 5px;
      margin-top: 3px;
      
    }


  .item {
     min-width: 290px;
  }

  
  /*
    .item-group:focus {
      background-color: #fefefe;
      border: 2px dashed rgb(122, 176, 197);
      margin-top: 3px;
    }


    .item:hover {
      background-color: #fefefe;
      border: 2px dashed rgb(122, 176, 197);
      margin-top: 3px;
    }
    */
    .item-sub {
    margin: 0 0 0 5px;
  }

    div {
      list-style: none;
    }

    .flip-list-move {
      transition: transform 0.5s;
    }

    .no-move {
      transition: transform 0s;
    }
</style>




// WEBPACK FOOTER //
// src/components/procedure/nested-property.vue